var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MainNav'),_c('router-view',{staticClass:"router_view"}),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }